export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14507.d10c8f52.jpg";